// extracted by mini-css-extract-plugin
module.exports = {"app":"app_app__M9MMq","main":"app_main__3yfFw"};